// VirtualJoystick.js - 虚拟摇杆组件
export default class VirtualJoystick {
    constructor(scene, x, y, radius = 60) {
        this.scene = scene;
        this.baseX = x;
        this.baseY = y;
        this.radius = radius;
        this.stickRadius = 20;
        this.maxDistance = radius - this.stickRadius;
        
        // 当前摇杆位置
        this.stickX = x;
        this.stickY = y;
        
        // 是否正在拖拽
        this.isActive = false;
        
        // 方向状态（模拟 cursors 对象）
        this.cursors = {
            left: { isDown: false },
            right: { isDown: false },
            up: { isDown: false },
            down: { isDown: false }
        };
        
        // 创建图形
        this.createGraphics();
        
        // 设置交互
        this.setupInteraction();
    }
    
    createGraphics() {
        // 创建底座（外圈）
        this.base = this.scene.add.circle(
            this.baseX,
            this.baseY,
            this.radius,
            0x333333,
            0.6
        );
        this.base.setScrollFactor(0);
        this.base.setDepth(10000);
        this.base.setInteractive();
        
        // 创建摇杆（内圈）
        this.stick = this.scene.add.circle(
            this.stickX,
            this.stickY,
            this.stickRadius,
            0x4cc9f0,
            0.8
        );
        this.stick.setScrollFactor(0);
        this.stick.setDepth(10001);
    }
    
    setupInteraction() {
        // 底座点击/触摸
        this.base.on('pointerdown', (pointer) => {
            this.isActive = true;
            this.updateStickPosition(pointer.x, pointer.y);
        });
        
        // 使用场景的输入管理器来监听全局事件
        this.pointerMoveHandler = (pointer) => {
            if (this.isActive && pointer.isDown) {
                this.updateStickPosition(pointer.x, pointer.y);
            }
        };
        
        this.pointerUpHandler = () => {
            if (this.isActive) {
                this.resetStick();
            }
        };
        
        // 注册全局事件监听器
        this.scene.input.on('pointermove', this.pointerMoveHandler);
        this.scene.input.on('pointerup', this.pointerUpHandler);
    }
    
    updateStickPosition(x, y) {
        // 计算相对于底座中心的偏移
        const dx = x - this.baseX;
        const dy = y - this.baseY;
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        // 限制在最大距离内
        if (distance > this.maxDistance) {
            const angle = Math.atan2(dy, dx);
            this.stickX = this.baseX + Math.cos(angle) * this.maxDistance;
            this.stickY = this.baseY + Math.sin(angle) * this.maxDistance;
        } else {
            this.stickX = x;
            this.stickY = y;
        }
        
        // 更新摇杆位置
        this.stick.x = this.stickX;
        this.stick.y = this.stickY;
        
        // 更新方向状态
        this.updateDirection();
    }
    
    updateDirection() {
        // 计算偏移量
        const dx = this.stickX - this.baseX;
        const dy = this.stickY - this.baseY;
        
        // 阈值（避免微小移动触发）
        const threshold = 10;
        
        // 重置所有方向
        this.cursors.left.isDown = false;
        this.cursors.right.isDown = false;
        this.cursors.up.isDown = false;
        this.cursors.down.isDown = false;
        
        // 根据偏移量设置方向
        if (Math.abs(dx) > threshold) {
            if (dx < 0) {
                this.cursors.left.isDown = true;
            } else {
                this.cursors.right.isDown = true;
            }
        }
        
        if (Math.abs(dy) > threshold) {
            if (dy < 0) {
                this.cursors.up.isDown = true;
            } else {
                this.cursors.down.isDown = true;
            }
        }
    }
    
    resetStick() {
        this.isActive = false;
        this.stickX = this.baseX;
        this.stickY = this.baseY;
        this.stick.x = this.stickX;
        this.stick.y = this.stickY;
        
        // 重置所有方向
        this.cursors.left.isDown = false;
        this.cursors.right.isDown = false;
        this.cursors.up.isDown = false;
        this.cursors.down.isDown = false;
    }
    
    getCursors() {
        return this.cursors;
    }
    
    setVisible(visible) {
        this.base.setVisible(visible);
        this.stick.setVisible(visible);
    }
    
    destroy() {
        // 移除事件监听器
        if (this.scene && this.scene.input) {
            if (this.pointerMoveHandler) {
                this.scene.input.off('pointermove', this.pointerMoveHandler);
            }
            if (this.pointerUpHandler) {
                this.scene.input.off('pointerup', this.pointerUpHandler);
            }
        }
        
        if (this.base) this.base.destroy();
        if (this.stick) this.stick.destroy();
    }
}

